import type { CSSProperties } from 'react'
import type { SxProps, Theme } from '@mui/material/styles'

type VehiclePictureUploadDialogStyleMap = {
    content: SxProps<Theme>
    previewContainer: SxProps<Theme>
}

export const vehiclePictureUploadDialogStyles: VehiclePictureUploadDialogStyleMap = {
    content: { display: 'flex', flexDirection: 'column', gap: 2, pt: 1 },
    previewContainer: { maxHeight: 400, overflow: 'auto', textAlign: 'center', bgcolor: '#111' },
}

export const vehiclePictureUploadPreviewImageStyle: CSSProperties = {
    maxWidth: '100%',
    maxHeight: 380,
    display: 'block',
}
